import { createFileRoute, notFound } from '@tanstack/react-router';
import { getPartnership, loadPartnershipBody } from '@content/partnerships';
import { cmsHead } from '@lib/cmsHead';
import { PartnershipPage } from '@templates/PartnershipPage';

export const Route = createFileRoute('/partnerships/$slug')({
  loader: async ({ params }) => {
    const partner = getPartnership(params.slug);
    if (!partner) throw notFound();
    return { partner, ...(await loadPartnershipBody(partner.slug)) };
  },
  head: ({ loaderData }) =>
    loaderData ? cmsHead(loaderData.partner.seo, `/partnerships/${loaderData.partner.slug}`) : {},
  component: PartnershipRoute,
});

function PartnershipRoute() {
  const { partner, body, resources } = Route.useLoaderData();
  return <PartnershipPage partner={partner} body={body} resources={resources} />;
}
